import { emptyDecorator } from '@/catalog/constants/emptyDecorator';
import { FieldType } from '@/catalog/constants/fieldTypes';
import { ALL_CONTEXTS } from '@/common/constants/context';
import { dictionaryRepository } from '@/common/repositories/DictionaryRepository';
import Gem from '@/product/entity/Gem';
export const FIELD_GEM_TYPE = {
    key: 'gemType',
    label: 'Material',
    fullLabel: 'Material',
    type: FieldType.Scalar,
    spGroupId: null,
    getter(p) {
        return this.getterPlain(p);
    },
    getterPlain(p) {
        if (p instanceof Gem) {
            const gemTypeDict = dictionaryRepository.getGemTypeById(p.gemType);
            if (gemTypeDict) {
                return gemTypeDict.title;
            }
            return p.gemType ?? null;
        }
        return null;
    },
    decorator: emptyDecorator,
    iteratee: null,
    contexts: ALL_CONTEXTS,
};
